<app-loader></app-loader>
<div
  *ngIf="authService.isAuthorized && authService.hasValidToken; else redirectInfo"
  class="h-full w-full flex flex-col overflow-hidden"
>
  <div>
    <div
      class="border-t border-primary bg-secondary text-center text-white"
      *ngIf="systemDataService.systemData?.wersjaTestowa"
      i18n
      >Wersja testowa systemu!</div
    >
    <app-header (showMobileMenu)="showMobileMenu()"></app-header>
  </div>
  <div class="flex flex-col grow overflow-auto">
    <app-breadcrumb></app-breadcrumb>

    <div class="flex w-full px-4 py-6 lg:gap-5 lg:px-5 xl:px-15 xxl:gap-5 xxl:px-20">
      <app-menu [isMobileMenuVisible]="isMobileMenuVisible" (hideMobileMenu)="hideMobileMenu()"></app-menu>
      <main class="flex-auto overflow-auto">
        <router-outlet></router-outlet>
      </main>
    </div>
    <app-footer class="mt-auto"></app-footer>
  </div>
</div>

<ng-template #redirectInfo>
  <p class="flex h-full w-full items-center justify-center text-lg font-bold" i18n
    >Proszę czekać, trwa przekierowywanie...</p
  >
</ng-template>
